import React from 'react';
import { motion } from 'framer-motion';


const TimelineSection = () => {
  const timelineEvents = [
    {
      year: "2009",
      title: "Création d\'ADT Express à Paris",
      description: "Avec une mission simple : connecter la diaspora ivoirienne à ses proches"
    },
    {
      year: "2012",
      title: "Premiers conteneurs complets expédiés",
      description: "Ouverture du service professionnel"
    },
    {
      year: "2015",
      title: "Lancement de l\'enlèvement partout en France",
      description: "Plus besoin d\'être à Paris"
    },
    {
      year: "2018",
      title: "30 000 colis expédiés",
      description: "ADT Express devient une référence pour la diaspora"
    },
    {
      year: "2022",
      title: "Lancement du suivi en temps réel",
      description: "Et de l\'espace client digital"
    },
    {
      year: "2025",
      title: "50 000+ colis expédiés",
      description: "Lancement de l\'offre EX1 pour les professionnels"
    }
  ];

  return (
    <div className="py-16 sm:py-20">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <h2 className="text-3xl sm:text-4xl font-bold text-slate-900 mb-4">
            Notre Histoire
          </h2>
          <p className="text-lg text-gray-700 mb-4">
            Plus de 15 ans au service de la diaspora ivoirienne
          </p>
        </motion.div>

        {/* Vertical Timeline */}
        <div className="relative">
          {/* Vertical Green Line */}
          <div className="absolute left-8 top-0 bottom-0 w-0.5 bg-green-600" />

          {/* Timeline Events */}
          <div className="space-y-12">
            {timelineEvents?.map((event, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, x: -30 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                className="relative flex items-start gap-8"
              >
                {/* Year Circle */}
                <div className="relative z-10 flex-shrink-0">
                  <div className="w-16 h-16 bg-green-600 rounded-full flex items-center justify-center shadow-lg">
                    <span className="text-white font-bold text-sm">{event?.year}</span>
                  </div>
                </div>

                {/* Content Card */}
                <div className="flex-1 bg-white rounded-xl shadow-md p-6 hover:shadow-lg transition-shadow duration-300">
                  <h3 className="text-xl font-bold text-slate-900 mb-2">
                    {event?.title}
                  </h3>
                  <p className="text-slate-600">
                    {event?.description}
                  </p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TimelineSection;